import { Link } from "@tanstack/react-router";

import { pathFor, useLocale, type Locale } from "@/lib/i18n";

const TEXT: Record<Locale, { text: string; apply: string; visit: string; fees: string }> = {
  sv: {
    text: "Funderar ni på skolstart hos oss? Ansökningar tas emot löpande.",
    apply: "Gör en ansökan",
    visit: "Boka ett besök",
    fees: "Se avgifter",
  },
  en: {
    text: "Considering a place with us? We accept applications all year round.",
    apply: "Apply for a place",
    visit: "Book a visit",
    fees: "See fees",
  },
  es: {
    text: "¿Pensáis en una plaza con nosotros? Aceptamos solicitudes todo el año.",
    apply: "Enviar solicitud",
    visit: "Reservar una visita",
    fees: "Ver tarifas",
  },
};

/** Diskret CTA-rad att placera mitt i en längre text. */
export function InlineCta({ locale, className = "" }: { locale?: Locale; className?: string }) {
  const urlLocale = useLocale();
  const loc = locale ?? urlLocale;
  const t = TEXT[loc];

  return (
    <aside
      className={`not-prose rounded-xl border border-border bg-sand p-5 sm:p-6 ${className}`.trim()}
    >
      <p className="text-sm leading-relaxed text-foreground/90">{t.text}</p>
      <div className="mt-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4">
        <Link
          to={pathFor("/ansokan", loc) as never}
          className="flex min-h-11 items-center justify-center rounded-md bg-primary px-5 text-sm font-medium text-primary-foreground transition-opacity hover:opacity-90"
        >
          {t.apply}
        </Link>
        <Link
          to={pathFor("/boka-besok", loc) as never}
          className="flex min-h-11 items-center justify-center rounded-md border border-border bg-card px-5 text-sm font-medium transition-colors hover:bg-background"
        >
          {t.visit}
        </Link>
        <Link
          to={pathFor("/avgifter", loc) as never}
          className="text-sm link-quiet"
        >
          {t.fees}
        </Link>
      </div>
    </aside>
  );
}
